import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
export default {
  data() {
    return {
      VALID_DOCUMENTS_EXTENSIONS: ["pdf", "doc", "docx"],
      VALID_IMAGES_EXTENSIONS: ["jpg", "jpeg", "png", "tiff"]
    };
  },
  computed: {
    fileType() {
      var _context, _context2;
      if (_includesInstanceProperty(_context = this.VALID_DOCUMENTS_EXTENSIONS).call(_context, this.fileExtension.toLowerCase())) return "document";else if (_includesInstanceProperty(_context2 = this.VALID_IMAGES_EXTENSIONS).call(_context2, this.fileExtension.toLowerCase())) return "image";else return false;
    }
  }
};